// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"UTmsnHXvBK5HqEzSL24hu_0","row":"_2jA-i-4j02-MlB37ZRVW8__0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78bd5d6f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/topologymap/components/element/ShapeElement.vue
// module id = xo7W
// module chunks = 75